import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-police',
  templateUrl: './privacy-police.component.html',
  styleUrls: ['./privacy-police.component.scss']
})
export class PrivacyPoliceComponent {}
